import { render } from "./Index.vue?vue&type=template&id=20a732d0&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=20a732d0&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__